import { render, staticRenderFns } from "./edit-zhuanbing.vue?vue&type=template&id=a2d7119c&scoped=true&"
import script from "./edit-zhuanbing.vue?vue&type=script&lang=ts&"
export * from "./edit-zhuanbing.vue?vue&type=script&lang=ts&"
import style0 from "./edit-zhuanbing.vue?vue&type=style&index=0&id=a2d7119c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d7119c",
  null
  
)

export default component.exports